export default __webpack_public_path__ + "static/media/invoiceSummaryBlankSlate1.a8d8bc9a.png";